


























































import { PartyModel, ApplicationUserModel, ProductModel } from '@/libs/Api';
import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator';
import { partiesStore } from '@/libs/parties/+state/store';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import { CrudAction } from '@/libs/core/crud/crud-action';
import { createCrudQueryPayload } from '@/libs/core/crud/crud-query';
import { CrudGetter } from '@/libs/core/crud/crud-getter';
import { productsStore } from '@/libs/products/+state/store';
import { Constants } from '@/libs/constants/constants';

@Component
export default class Client extends Vue {

    tab = "General";

    get client(): PartyModel {
        return partiesStore.useGetter(CrudGetter.Detail, this.id);
    }

    get user(): ApplicationUserModel {
        return applicationUserStore.useGetter(CrudGetter.Detail);
    }

    get creditExchangeRate() {
        const creditProduct = productsStore.useGetter(CrudGetter.Detail, Constants.CreditProductId) as ProductModel;
        return creditProduct?.exchangeRate;
    }

    @Prop() id!: string;

    @Watch("id")
    idChanged () {
        this.loadClient();
    }

    mounted () {
        this.loadClient();
        this.getCreditProduct();
    }

    loadClient () {
        partiesStore.dispatch(CrudAction.Get, { id: this.id, key: this.id });
    }

    computeCreditPrice (creditValue: number | null, exchangeRate: number | null) {
        if (creditValue != null && exchangeRate != null) {
            return parseFloat((creditValue * exchangeRate).toFixed(2));
        }
        return "--";
    }

    setTab (value: string) {
        this.tab = value;
    }

    getCreditProduct () {
        productsStore.dispatch(CrudAction.Get, { id: Constants.CreditProductId, key: Constants.CreditProductId });
    }
    
}
